import { render } from "./Error404.vue?vue&type=template&id=4f43215b"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"
script.render = render

export default script